/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
  'use strict';

  import Block = Models.Block;
  import IBlockConnections = Models.IBlockConnections;

  export interface IRedundantBlocksModalControllerScope extends ng.IScope {
    blocksPrimary: Block[];
    blocksRedundant: Block[];
    redundancy: {
      primary: string;
      secundary: string;
    };
    selected: {
      name: string;
      primary: Block;
      redundant: Block;
    };
    nameInUse: boolean;
    modalClose: () => void;
    modalSave: () => void;
    clear: () => void;
    checkIfAvailable: () => Promise<void>;
    invalidForm: () => boolean;
  }

  export class RedundantBlocksModalController {
    public static templateURL: string =
      'decorators/modals/redundant-blocks-modal.html';
    public static ID: string = '#id-redundant-blocks-modal';
    public static $name: string = 'redundantBlocksModalController';
    public static $inject: string[] = [
      '$scope',
      'close',
      '$timeout',
      'blockService',
      'redundantBlocks'
    ];

    constructor(
      $scope: IRedundantBlocksModalControllerScope,
      close: (parameters: ngModal.ICloseParameters) => void,
      $timeout: ng.ITimeoutService,
      private blockService: Services.BlockService,
      redundantBlocks: any,
    ) {
      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      $scope.modalClose = (): void => {
        close(undefined);
      };

      /**
       * map redundancy key for block, and update it
       */
      $scope.modalSave = (): void => {
        let redundancyGroup = this.getRedundancyGroup(
          $scope.selected.name,
          $scope.selected.primary,
          $scope.selected.redundant
        );
        $scope.selected.primary.config.redundancyGroup = redundancyGroup;
        $scope.selected.redundant.config.redundancyGroup = redundancyGroup;
        this.blockService.updateBlock($scope.selected.primary);
        this.blockService.updateBlock($scope.selected.redundant);
        close(undefined);
      };
      
      $scope.clear = (): void => {
        this.initData($scope);
      };

      $scope.$watch('selected.primary', (newVal: Block) => {
        $scope.selected.primary = newVal;
        this.validateSelection($scope);
      });

      $scope.checkIfAvailable = async(): Promise<void> => {
        $scope.nameInUse = redundantBlocks.some( (block: Models.IRedundantBlock) => {
          return block.name == $scope.selected.name;
        });
      }

      $scope.invalidForm = (): boolean => {
        return $scope.nameInUse == true && $scope.selected.name != '';
      }

      this.initData($scope);
    }

    

    getRedundancyGroup(name: string, primaryBlock: Block, redundantBlock: Block) {
      return {
        name: name,
        redundancyIds: primaryBlock.id + '-' + redundantBlock.id,
        primary: primaryBlock.name,
        redundant: redundantBlock.name
      };
    }

    initData($scope: IRedundantBlocksModalControllerScope) {
      $scope.blocksPrimary = [];
      $scope.blocksRedundant = [];
      $scope.selected = {
        name: "",
        primary: Block.Empty(),
        redundant: Block.Empty()
      };
      this.blockService.getAllBlocksPromise().then((blocks: Block[]) => {
        $scope.blocksPrimary = blocks.filter((block: Block) => {
          return block.blockTypeNaturalKey == 'V_TS' && !block.config.redundancyGroup;
        }).sort(this.compare);
        $scope.blocksPrimary = [Models.Block.Empty()].concat(
          $scope.blocksPrimary
        );
        this.validateSelection($scope);
      });
    }

    compare(a: Block, b: Block) {
      const bandA = a.name.toUpperCase();
      const bandB = b.name.toUpperCase();
    
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }

    /**
     * set the values for the second select depending of the values in the first dropdown
     * @param $scope scope =)
     */
    validateSelection($scope: IRedundantBlocksModalControllerScope) {
      $scope.blocksRedundant = [];
      $scope.blocksRedundant = $scope.blocksPrimary.filter((block: Block) => {
        return block.id != $scope.selected.primary.id && block.name != '';
      });
      $scope.blocksRedundant = [Models.Block.Empty()].concat(
        $scope.blocksRedundant
      );
      if($scope.selected.redundant == $scope.selected.primary){
        $scope.selected.redundant = Models.Block.Empty();
      }
    }
  }
}
